import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import './style.scss';

const DiscountLabel = ({ className, data, align = 'right' }) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  return (
    <ul className={cx('goods-ui-labels', `is-align-${align}`, className)} data-label-type="discount">
      {
        data.map((label, index) => {
          const { tag, promotion, coupon } = label;
          const key = `goods-ui-sell-labels-${index}`;
          let text;

          switch (tag) {
            case 'promotion': {
              text = `满${promotion.requireMoney}减${promotion.parValue}`;
              break;
            }
            case 'coupon': {
              // 新版统一标签修改成-20200226
              // discount 折扣-> 券 满x y折”，若x=0，则标签显示为”券 立享y元
              // moneyOff 满减-> 券 满x减y”，若x=0，则标签显示为”券 立减￥y
              // http://wiki.int.zuzuche.info/pages/viewpage.action?pageId=134480034
              let { requireMoney } = coupon;
              const { maxDiscount, maxParValue } = coupon;
              requireMoney && (requireMoney = parseInt(requireMoney, 10));
              if (requireMoney) {
                text = coupon.type === 'discount' ? `满${requireMoney}元${maxDiscount}折` : `满${requireMoney}减${maxParValue}`;
              } else {
                text = coupon.type === 'discount' ? `立享${maxDiscount}折` : `立减¥${maxParValue}`;
              }
              break;
            }
            default: {
              text = label.text;
            }
          }

          return (
            <li key={key}>
              {
                tag === 'coupon' && <div className="icon">券</div>
              }
              <p>{text}</p>
            </li>
          );
        })
      }
    </ul>
  );
};

DiscountLabel.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  align: PropTypes.string
};

export default DiscountLabel;
